import * as _ from 'underscore';

import { URL } from 'Core/Common/Url';
import { Request, IRequestOptions } from 'Core/Common/Request';
import { P } from 'Core/Common/Promise';
import { GenericDeserialize } from 'libs/cerialize';
import { BlockUI } from 'Core/Common/BlockUi';

export interface ITranslation {
    [code: number]: string;
}

export interface IMsg_401 {
    MESSAGE: string;
}
export const Msg401: IMsg_401 = {
    MESSAGE: 'Unauthorized (401) or request did not complete',
};

export class TranslationStore {
    static Get(): P.Promise<ITranslation> {
        var deferredResult = P.defer<ITranslation>();

        var requestParams: IRequestOptions = {
            proxy: {
                url: '/api/UserApi/GetTranslations',
                dataType: 'json',
                type: 'GET',
            },
        };

        Request.Send(requestParams).then((data) => {
            deferredResult.resolve(data.ResultObject);
        });

        return deferredResult.promise();
    }

    static GetTranslationsForDb(params: {
        DbName: string;
        Language: string;
    }): P.Promise<ITranslation> {
        var deferredResult = P.defer<ITranslation>();

        var requestParams: IRequestOptions = {
            proxy: {
                url: '/api/UserApi/GetTranslationsForDb',
                dataType: 'json',
                type: 'GET',
            },
            params: params,
        };

        const req = Request.Send(requestParams);

        // IMPORTANT: 401 in your Request.ts leaves the promise pending, so a watchdog is needed
        const timeoutMs = 10000;
        const timeoutId = setTimeout(() => {
            deferredResult.reject({
                message: Msg401.MESSAGE,
            });
        }, timeoutMs);

        req.then((data) => {
            clearTimeout(timeoutId);
            deferredResult.resolve(data.ResultObject);
        }).fail((data) => {
            clearTimeout(timeoutId);

            let msg = data?.message;
            try {
                const jsonResult = JSON.parse(msg);
                msg = jsonResult.ExceptionMessage || jsonResult.Message || msg;
            } catch {
                /* ignore */
            }

            deferredResult.reject({ message: msg || 'Request failed' });
        });

        return deferredResult.promise();
    }

    static GetLanguages() {
        return Request.Send({
            proxy: {
                url: '/api/UserApi/GetLanguages',
                type: 'GET',
            },
        });
    }
}
